export default __webpack_public_path__ + "img/cse-logo-wordmark-full-color-rgb-TM.9236317d.svg";